/* eslint-disable react/no-array-index-key */

import React, { PureComponent } from 'react';
import Scrollbar from 'react-smooth-scrollbar';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import MagnifyIcon from 'mdi-react/MagnifyIcon';
import ChatContact from './ChatContact';
import ChatBubble from './ChatBubble';
import ChatField from './ChatField';
import ChatTopbar from './ChatTopbar';
import { checkKey } from "../../../Services/SecurityService";
import { useBasicAuth } from '../../../../shared/components/auth/withBasicAuth';
import { environment } from '../../../environment';
import { check, checkTokenExists, addChat, findAllChatByUser, send, markAsReceived, markAsRead } from "../../../Services/ChatService";


class Chat extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      currentMessages: [],
      currentChat: '',
      currentDialog: '',
      openContacts: false,
      contacts: [],
      contactsSearch: [],
      currentUser: {
        avatar: `${process.env.PUBLIC_URL}/img/ava.png`,
        name: '',
        userName: 'user0',
      },
      user: {},
      intervalId: 0,
    };
    if(!checkTokenExists()){
      if(this.state.intervalId !== 0){
        clearInterval(this.state.intervalId);
      }
      check();
    }

    this.onKeyUp = this.onKeyUp.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  config(user){
    let currentUser = {
      avatar: `${process.env.PUBLIC_URL}/img/ava.png`,
      name: user.name,
      userName: 'user'+user.id,
    };
    this.setState({ currentUser, user });
  }

  setAvatar(obj){
    if(obj.avatar === null || obj.avatar === undefined || obj.avatar === ''){
      obj.avatar = `${process.env.PUBLIC_URL}/img/12.png`
    }
  }

  load(){
    if(checkTokenExists()){
      let user = environment.getUser();
      this.loadMessagens(user);
    }else{
      clearInterval(this.state.intervalId);
    }
  }

  init(){
    const loadBounded = this.load.bind(this);
    if(this.state.intervalId === 0){
      let intervalId = setInterval(loadBounded, 10000);
      this.setState({intervalId: intervalId}, () => {
        useBasicAuth.addInterval("MENU_CHAT_VIEW_PAGE", intervalId);
        this.load();
      });
    }
  }

  loadMessagens(user){
    findAllChatByUser(user.id)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        if(data.chatList !== null && data.chatList !== undefined && data.chatList.length > 0){
          let msgs = [];//myContacts;
          for(let i = 0; i < data.chatList.length; i++){
            this.setAvatar(data.chatList[i]);
            data.chatList[i].newMessages = false;
            msgs.push(data.chatList[i]);
          }
          // console.log("msgs");
          // console.log(msgs);
          let contactsOld = this.state.contacts;

          for(let i = 0; i < msgs.length; i++){
            for(let j = 0; j < msgs[i].messages.length; j++){
              msgs[i].messages[j].newMessages = false;
              if(this.state.currentUser.userName !== msgs[i].messages[j].userName && !msgs[i].messages[j].read){
                msgs[i].newMessages = true;
                msgs[i].messages[j].newMessages = true;
                break;
              }
            }
          }

          this.setState({ contacts: msgs, contactsSearch: msgs }, () => {
            let contactAlert = localStorage.getItem(environment.CHAT_CONTACT);
            if(contactAlert !== null && contactAlert !== undefined && contactAlert.length > 0){
              localStorage.removeItem(environment.CHAT_CONTACT);
              this.onOpenChat(contactAlert, null);
            }

            let diff = true;
            let newMessages = false;
            for(let i = 0; i < msgs.length; i++){
              let contact = msgs[i];
              newMessages = false;
              for(let j = 0; j < contactsOld.length; j++){

                if(contactsOld[j].userName === contact.userName){

                  if(this.state.currentChat === contact.userName){
                    for(let m = 0; m < contact.messages.length; m++){
                      if(this.state.currentUser.userName !== contact.messages[m].userName && !contact.messages[m].read){
                        newMessages = true;
                        break;
                      }
                    }
                    if(newMessages){
                      contact.newMessages = false;
                      this.setState({
                        currentMessages: contact.messages,
                        currentDialog: contact
                      }, () => {
                        diff = false;
                        markAsReceived(user.id).then(data => {
                          this.scrollToBottom();
                        });
                      });
                    }else{
                      contact.newMessages = false;
                      this.setState({
                        currentMessages: contact.messages,
                        currentDialog: contact
                      });
                    }
                  }else{
                    if(diff){
                      if(contactsOld[j].messages.length !== contact.messages.length){
                          diff = false;
                          markAsReceived(user.id).then(data => {});
                          // console.log("markAsReceived only once");
                      }
                    }
                  }
                  break;
                }
              }
            }
          });
        }
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  componentDidMount() {
    // console.log(this.props.contactProps);
    if(checkKey("MENU_CHAT_VIEW")){
      let user = environment.getUser();
      this.config(user);
      this.loadMessagens(user);
      this.init();
    }
  }

  componentWillUnmount() {
    
  }

  configDialog(dialog){
    if(dialog !== null && dialog !== undefined){
      if(dialog.id === null){
        dialog.user2 = this.state.user;
        dialog.status = 'ATIVO';
        dialog.deleted = '';
        dialog.createdAt = '';
        dialog.updatedAt = '';
      }
    }
    return dialog;
  }

  onOpenChat = (contact, e) => {
    const { contacts } = this.state;
    
    if(e !== null && e !== undefined){
      e.preventDefault();
    }
    // console.log("onOpenChat: " + contact);
    const dialog = this.configDialog(contacts.find(c => c.userName === contact));
    const messages = dialog.messages || null;
    // console.log("dialog:");
    // console.log(dialog);
    // console.log("messages: ");
    // console.log(messages);
    this.setState({
      currentChat: contact,
      currentMessages: messages,
      currentDialog: dialog
    }, () => {
      this.scrollToBottom();
    });
  };

  onOpenContacts = () => {
    this.setState(prevState => ({ openContacts: !prevState.openContacts }));
  };

  moveScroll(){
    let scrollbarId = document.getElementById("scrollbarId");
    scrollbarId.scrollTop = scrollbarId.scrollHeight;
    // let scrollbarDivs = document.getElementById("scrollbarDivs");
    // if(scrollbarId !== null && scrollbarId !== undefined && scrollbarDivs !== null && scrollbarDivs !== undefined){
    //   let scrollbarId_offsetHeight = scrollbarId.offsetHeight;
    //   let scrollbarId_scrollbarDivs = scrollbarDivs.offsetHeight;
    //   let barHeight = scrollbarId.children[2].childNodes[0].style.height.replace("px","");;
    //   let newPositionBar = scrollbarId_offsetHeight - barHeight;
    //   let scrollBottom = scrollbarId_scrollbarDivs - scrollbarId_offsetHeight;
    //   scrollbarId.children[0].style.transform = "translate3d(0px, -" + scrollBottom + "px, 0px)";
    //   scrollbarId.children[2].children[0].style.transform = "translate3d(0px, " + newPositionBar + "px, 0px)";
    // }
  }

  scrollToBottom(){
    // setTimeout(() => {this.moveScroll();}, 100);
    this.moveScroll();

    if(this.state.currentDialog.id !== null && this.state.currentDialog.id !== undefined){
      // console.log("scrollToBottom markAsRead " + this.state.currentDialog.userName);
      markAsRead(this.state.currentDialog.id).then(data => {});
    }
  }

  createChat(request){
    addChat(request)
    .then(response => {
      if(response !== null && response !== undefined && response.error === undefined){
        if(response.erros.length === 0){
          // console.log(this.state.currentMessages);
          // console.log(response.chatMessageList);
          let currentMessages = this.state.currentMessages;
          for(let i = 0; i < response.chatMessageList.length; i++){
            this.setAvatar(response.chatMessageList[i]);
            currentMessages.push(response.chatMessageList[i]);
          }
          // console.log(this.state.currentDialog);
          // console.log(response.chat);
          let currentDialog = response.chat;
          currentDialog.messages = currentMessages;
          this.setAvatar(currentDialog);
          
          // console.log(this.state.contacts);
          let contacts = this.state.contacts;
          for(let i = 0; i < contacts.length; i++){
            if(contacts[i].userName === currentDialog.userName){
              contacts[i] = currentDialog;
              break;
            }
          }
          
          this.setState({ contacts, contactsSearch: contacts, currentDialog, currentMessages});
        }else{
          if(response.erros !== undefined && response.erros !== undefined && response.erros.length > 0){
            for(let i = 0; i < response.erros.length; i++){
              this.show('danger', this.props.t('erros.'+response.erros[i]));
            }
          }
        }
      } else {
        this.show('danger', this.props.t('forms.dataCreateError'));
      }
    });
  }

  sendMessageChat(request){
    send(request)
    .then(response => {
      if(response !== null && response !== undefined && response.error === undefined){
        if(response.erros.length === 0){
          // console.log(this.state.currentMessages);
          // console.log(response.chatMessageList);
          let currentMessages = [];
          for(let i = 0; i < this.state.currentMessages.length; i++){
            currentMessages.push(this.state.currentMessages[i]);
          }
          for(let i = 0; i < response.chatMessageList.length; i++){
            this.setAvatar(response.chatMessageList[i]);
            currentMessages.push(response.chatMessageList[i]);
          }
          // console.log(currentMessages);
          let currentDialog = this.state.currentDialog;
          currentDialog.messages = currentMessages;
          this.setAvatar(currentDialog);
          
          let contacts = this.state.contacts;
          for(let i = 0; i < contacts.length; i++){
            if(contacts[i].userName === currentDialog.userName){
              contacts[i] = currentDialog;
              break;
            }
          }
          
          this.setState({ contacts, contactsSearch: contacts, currentDialog, currentMessages}, () => {
            this.scrollToBottom();
          });
        }else{
          if(response.erros !== undefined && response.erros !== undefined && response.erros.length > 0){
            for(let i = 0; i < response.erros.length; i++){
              this.show('danger', this.props.t('erros.'+response.erros[i]));
            }
          }
        }
      } else {
        this.show('danger', this.props.t('forms.dataCreateError'));
      }
    });
  }

  sendText(text){
    // console.log(text);
    let message = {
      id: null,
      name: null,
      chat: this.state.currentDialog,
      user: this.state.user,
      message: text,
      read: false,
      received: false,
      status: 'ATIVO',
      deleted: '',
      createdAt: '',
      updatedAt: ''
    }
    let request = {
      chat: null,
      chatMessageList: [message]
    }
    // console.log(request);

    if(this.state.currentDialog.id === null){
      request.chat = this.state.currentDialog;
      this.createChat(request);
    }else{
      this.sendMessageChat(request);
    }
  }

  onKeyUp = (e) => {
    if (e.key === "Enter") {
      let text = e.target.value;
      document.getElementById("chatField").value = "";
      this.sendText(text);
    }
  }

  onClick = () => {
    let text = document.getElementById("chatField").value;
    document.getElementById("chatField").value = "";
    this.sendText(text);
  }

  updateField(event) {
    let textFilter = event.target.value;
    textFilter = textFilter.toLowerCase();
    let contactsSearch = this.state.contacts.filter(contact => contact.name.toLowerCase().includes(textFilter));
    this.setState({ contactsSearch });
  }

  // onScroll(e){
  //   console.log(e);
  //   // e.offset.y = 222;
  // }

  render() {
    const { t } = this.props;
    const { openContacts, currentChat, currentMessages, currentUser, contacts, contactsSearch } = this.state;
    const chatClass = classNames({
      chat: true,
      'chat--open': openContacts,
    });

    const contactsClass = classNames({
      'chat__contact-list': true,
      'chat__contact-list--open': openContacts,
    });

    return (
      <div
        className={chatClass}
        onClick={openContacts ? this.onOpenContacts : null}
        role="presentation"
      >
        <div className={contactsClass}>
          <div className="chat__search">
            <input className="chat__search-input" 
              name="search"
              onChange={e => this.updateField(e)}
              placeholder={t('forms.search')}
            />
            <MagnifyIcon />
          </div>
          <div className="chat__contacts">
            <Scrollbar className="scroll chat__contacts-scroll" alwaysShowTracks>
              {contactsSearch.map((c, i) => (
                <button key={i} type="button" onClick={e => this.onOpenChat(c.userName, e)}>
                  <ChatContact active={c.userName === currentChat} contact={c} />
                </button>
              ))}
            </Scrollbar>
          </div>
        </div>
        {currentChat === null || currentChat === ''
          ? (
            <div className="chat__dialog">
              <ChatTopbar onClick={this.onOpenContacts} />
              <div className="chat__dialog-select-message">
                <p>{t('chats.selectChatStart')}</p>
              </div>
            </div>
          )
          : (
            <div className="chat__dialog">
              <ChatTopbar
                contact={contacts.find(c => c.userName === currentChat)}
                onClick={this.onOpenContacts}
              />
              <div id="scrollbarId" className="scroll chat__scroll" style={{overflow: 'hidden', overflowY: 'auto'}}>
                <div className="chat__dialog-messages-wrap">
                  {currentMessages === null || currentMessages.length === 0
                    ? (
                      <div className="chat__dialog-messages">
                        <div className="chat__dialog-messages-empty">
                          <p>{t('chats.noMessages')}</p>
                        </div>
                      </div>
                    )
                    : (
                      <div id="scrollbarDivs" className="chat__dialog-messages">
                        {currentMessages.map((m, i) => (
                          <ChatBubble
                            key={i}
                            contact={m.userName === currentUser.userName ? currentUser
                              : contacts.find(c => c.userName === m.userName)}
                            message={m}
                            date={m}
                            active={m.userName === currentUser.userName}
                          />
                        ))}
                      </div>
                    )
                  }
                </div>                
              </div>
              <ChatField onKeyUp={this.onKeyUp} onClick={this.onClick} t={t}/>
            </div>
          )
        }
      </div>
    );
  }
}

export default withTranslation('common')(Chat);